var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternalNoteGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 1.66675H6.66669C3.33335 1.66675 1.66669 3.33341 1.66669 6.66675V17.5001C1.66669 17.9584 2.04169 18.3334 2.50002 18.3334H13.3334C16.6667 18.3334 18.3334 16.6667 18.3334 13.3334V6.66675C18.3334 3.33341 16.6667 1.66675 13.3334 1.66675ZM11.6667 12.7084H5.83335C5.49169 12.7084 5.20835 12.4251 5.20835 12.0834C5.20835 11.7417 5.49169 11.4584 5.83335 11.4584H11.6667C12.0084 11.4584 12.2917 11.7417 12.2917 12.0834C12.2917 12.4251 12.0084 12.7084 11.6667 12.7084ZM14.1667 8.54175H5.83335C5.49169 8.54175 5.20835 8.25842 5.20835 7.91675C5.20835 7.57508 5.49169 7.29175 5.83335 7.29175H14.1667C14.5084 7.29175 14.7917 7.57508 14.7917 7.91675C14.7917 8.25842 14.5084 8.54175 14.1667 8.54175Z",
    fill: "#2DB98D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalNoteGreen);
export default __webpack_public_path__ + "static/media/internalNote-green.6d56323dabf9962b63e110a934300b4e.svg";
export { ForwardRef as ReactComponent };